export default "__VITE_ASSET__DhopAbD3__"